// HR mode utilities
// - isHr is stored in localStorage as a boolean JSON value (true/false)
// - Visibility rule: only show HR features when explicitly true

const HR_STORAGE_KEY = 'isHr';

/**
 * 设置HR模式状态到localStorage
 */
export function setIsHr(value: boolean): void {
  try {
    localStorage.setItem(HR_STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    console.warn('Failed to save HR mode to localStorage:', error);
  }
}

/**
 * 从localStorage获取HR模式状态
 */
export function getIsHr(): boolean | null {
  try {
    const raw = localStorage.getItem(HR_STORAGE_KEY);
    if (raw === null) return null;
    
    const parsed = JSON.parse(raw);
    return typeof parsed === 'boolean' ? parsed : null;
  } catch (error) {
    console.warn('Failed to read HR mode from localStorage:', error);
    return null;
  }
}

/**
 * 判断是否启用HR功能
 * 只有明确设置为true时才启用
 */
export function isHrEnabled(): boolean {
  return getIsHr() === true;
}

/**
 * 根据当前URL路径设置HR模式
 * 当路径包含/hr时启用HR模式
 * 如果URL不包含/hr，则保留localStorage中的现有值
 */
export function applyHrFlagFromUrlOnce(): void {
  const pathname = window.location.pathname;
  
  // 只在路径包含/hr时设置为true
  // 不包含/hr时，保留现有值，不做修改
  if (pathname.includes('/hr')) {
    setIsHr(true);
  }
  // 注意：这里不再设置为false，保留现有值
}

/**
 * 清除HR模式设置
 */
export function clearHrFlag(): void {
  try {
    localStorage.removeItem(HR_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear HR mode from localStorage:', error);
  }
}

/**
 * 切换HR模式
 */
export function toggleHrMode(): boolean {
  const current = isHrEnabled();
  const newValue = !current;
  setIsHr(newValue);
  return newValue;
}

/**
 * 在Home页面重置HR模式
 * 根据URL路径决定是否为HR模式
 * 只应在Home页面调用
 */
export function resetHrModeOnHome(): void {
  const pathname = window.location.pathname;
  
  // 如果URL包含/hr，设置为true
  if (pathname.includes('/hr')) {
    setIsHr(true);
  } else {
    // 否则设置为false（普通用户模式）
    setIsHr(false);
  }
}
